var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransfer = function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 11.4c.5.7 1.4.8 2.1.3.7-.5.8-1.4.3-2.1L4.9 8h6.6c.8 0 1.5-.7 1.5-1.5S12.3 5 11.5 5H4.9l1.2-1.6c.5-.7.4-1.6-.3-2.1s-1.6-.4-2.1.3L0 6.5l3.7 4.9zM16.3 8.6c-.5-.7-1.4-.8-2.1-.3-.7.5-.8 1.4-.3 2.1l1.2 1.6H8.5c-.8 0-1.5.7-1.5 1.5S7.7 15 8.5 15h6.6l-1.2 1.6c-.5.7-.4 1.6.3 2.1s1.6.4 2.1-.3l3.7-4.9-3.7-4.9z"
  })));
};
export default SvgTransfer;